import { render, staticRenderFns } from "./PersonelForm.vue?vue&type=template&id=02cda12e&scoped=true"
import script from "./PersonelForm.vue?vue&type=script&lang=ts"
export * from "./PersonelForm.vue?vue&type=script&lang=ts"
import style0 from "./PersonelForm.vue?vue&type=style&index=0&id=02cda12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cda12e",
  null
  
)

export default component.exports